import { render } from "./NavigationControls.vue?vue&type=template&id=28748106&scoped=true"
import script from "./NavigationControls.vue?vue&type=script&lang=js"
export * from "./NavigationControls.vue?vue&type=script&lang=js"

import "./NavigationControls.vue?vue&type=style&index=0&id=28748106&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28748106"]])

export default __exports__